/*
 * @Description:ETC成本通行交易
 * @Author: WangYuhan
 * @Date: 2022-12-26 16:04:45
 * @LastEditTime: 2023-11-14 16:43:48
 * @LastEditors: WangYuhan
 */
import { listEtcWaybillOrderByWaybillNo } from '@/api/account';

// const storeModelName = 'ownerAccountsModule';
const state = {
  waybillNo: '',
  postParams: {
    page: 1,
    size: 10,
  },
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '序号',
        prop: 'sequence',
        checked: 1,
        width: 40,
        sortable: true,
      },
      {
        label: '高速入口',
        prop: 'enStation',
        checked: 1,
        width: 160,
        sortable: true,
      },
      {
        label: '高速出口',
        prop: 'exStation',
        checked: 1,
        width: 160,
        sortable: true,
      },
      {
        label: '下高速时间',
        prop: 'exTime',
        checked: 1,
        width: 125,
        sortable: true,
      },
      {
        label: '车牌号',
        prop: 'plateNum',
        checked: 1,
        width: 60,
        sortable: true,
      },
      {
        label: '消费金额',
        prop: 'fee',
        checked: 1,
        width: 80,
        sortable: true,
        slotName: 'sub-domain-fee',
      },
    ],
    total: 0,
  },
};
const getters = {};

const actions = {
  getList: async context => {
    const { code, data } = await listEtcWaybillOrderByWaybillNo({
      waybillNo: context.state.waybillNo,
    });
    if (code === 200) {
      data.forEach((item, index) => {
        item.sequence = index + 1;
      });
      context.commit('updateListData', {
        list: data,
        // total: data.total,
      });
    }
  },
};

const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = Object.assign({}, state.listData, payload);
  },
  updateState(state, payload) {
    state[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
